var map = {
	"./about1.jpg": 7850,
	"./about2.jpg": 3535,
	"./about3.jpg": 52,
	"assets/about/about1.jpg": 7850,
	"assets/about/about2.jpg": 3535,
	"assets/about/about3.jpg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4189;